import {
    AiprizeBusinessScope,
    AiprizeBusinessScopeSchema,
    AiprizeRegistrationRecord,
    AiprizeRegistrationRecordSchema,
    AiprizeRelatedCompany,
    AiprizeRelatedCompanySchema,
    AiprizeRelatedPerson,
    AiprizeRelatedPersonSchema,
} from '@40seas/entities/aiprize';
import { CreditSafeReportShareCapital, CreditSafeReportShareCapitalSchema } from '@40seas/entities/credit-safe';
import { VerifiedBusinessDetails, VerifiedBusinessDetailsSchema } from './credit-review.business-verification-verified-business-details';
import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';
import { BusinessDetails, BusinessDetailsSchema } from './credit-review.business-verification-verification.business-details';

export const VerifiedCompanyDetailsSchema = z
    .object({
        businessDetails: BusinessDetailsSchema.optional(),
        verifiedBusinessDetails: VerifiedBusinessDetailsSchema.optional(),
        relatedPersons: z.array(AiprizeRelatedPersonSchema).optional(),
        relatedCompanies: z.array(AiprizeRelatedCompanySchema).optional(),
        businessScope: AiprizeBusinessScopeSchema.optional(),
        registrationRecords: z.array(AiprizeRegistrationRecordSchema).optional(),
        shareCapital: CreditSafeReportShareCapitalSchema.optional(),
    })
    .strict();

export class VerifiedCompanyDetails extends FromSchema(VerifiedCompanyDetailsSchema) {
    businessDetails?: BusinessDetails;
    verifiedBusinessDetails?: VerifiedBusinessDetails;
    relatedPersons?: AiprizeRelatedPerson[];
    relatedCompanies?: AiprizeRelatedCompany[];
    businessScope?: AiprizeBusinessScope;
    registrationRecords?: AiprizeRegistrationRecord[];
    shareCapital?: CreditSafeReportShareCapital;
}
